export const environment = {
    localMode: false,
    encryptData: false,
    keyEcrypt: 'S@l$keyEcryptP1m13nT4Un1c4P4r4SynD1f1',
    environment: 'production',
    production: true,
    hmr: false,
    apiurl: 'https://l7mbgj91fj.execute-api.us-east-1.amazonaws.com/default/middleware-back-syndifi-production',
    apiurlBack: 'https://syndesk.syndifi.com/api/',
    //apiurl: "https://syndesk.syndifi.com/",
    IMAGE_SERVER_PATH: "https://danmsyndi.s3.amazonaws.com/",
    NOTE_SERVER_PATH: "https://files-repo-prod.s3.amazonaws.com/",
    //  IMAGE_SERVER_PATH: "https://syndifi-staging.s3.amazonaws.com/",
    SUBDOMAIN: location.host.split('.')[0],
    MASTER_DOMAIN: location.host.split('.')[1] + "." + location.host.split('.')[2],
    CHAT_PORT: 8084,
    URL_SYNDIFI: "https://syndesk.syndifi.com",
    DOC_MANAGER_LAMBDA_PROD: "https://ovmr3yqgu2.execute-api.us-east-1.amazonaws.com/default/docs-manager-prod",
    DOCUSIGN_LAMDBA_PROD: "https://5k5pcxp760.execute-api.us-east-1.amazonaws.com/prod/docusign",
    URL_SYNDIFY_PROD: "https://syndesk.syndifi.com/api/",
    CP_SYNDIFI_PROD: "https://cp.syndifi.com",
    REPO_SYNDIFI_PROD: "https://files-repo-prod.s3.amazonaws.com",
    MAILER_API_KEY: "uB4il4ZwbRQ41Zzq4zHX7IiOMMoTYUY2KlckB5l4",
    SQUARE_LAMBDA_PROD: "https://2olvpqnhoe.execute-api.us-east-1.amazonaws.com/default/square-service-prod",
    COUNTRY: "US",

    EMAIL_SENDER_LAMDBA: "https://gz7ob28eq2.execute-api.us-east-1.amazonaws.com/default/email-sender-aws",
    firebaseConfig: {
        apiKey: "AIzaSyDnLAlo0a6gWtKlFzuEz-vHUDqa9cuaLek",
        authDomain: "syndifi-kin.firebaseapp.com",
        projectId: "syndifi-kin",
        storageBucket: "syndifi-kin.appspot.com",
        messagingSenderId: "519805382904",
        appId: "1:519805382904:web:cbfd1d13fcc454d3b7cb0d",
        measurementId: "G-M9C76Y149G"
    }
};